/**
 * Logger utility that respects environment settings.
 * In production builds, debug logs are automatically removed.
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Debug logging - only shows in development
   */
  log: (...args: any[]): void => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Warning logging - only shows in development
   */
  warn: (...args: any[]): void => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Error logging - always shows (needed for production error tracking)
   */
  error: (...args: any[]): void => {
    console.error(...args);
  },

  /**
   * Info logging - always shows (for important production information)
   */
  info: (...args: any[]): void => {
    console.info(...args);
  }
};
